import CompactVehicleInfo from './CompactVehicleInfo'

export default CompactVehicleInfo
